import { render, staticRenderFns } from "./MenuView1.vue?vue&type=template&id=1146dacc&scoped=true"
import script from "./MenuView1.vue?vue&type=script&lang=js"
export * from "./MenuView1.vue?vue&type=script&lang=js"
import style0 from "./MenuView1.vue?vue&type=style&index=0&id=1146dacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1146dacc",
  null
  
)

export default component.exports